import { createRouter, createWebHistory } from 'vue-router'
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { nextTick } from 'vue';

import SignupView from "../views/SignupView.vue";
import SigninView from '../views/SigninView.vue';
import VerifyView from '../views/VerifyView.vue';
import AuthView from '../views/AuthView.vue';
import ForgotPasswordView from '../views/ForgotPasswordView.vue';
import ForgotPasswordView2 from '../views/ForgotPasswordView2.vue';
import ResetPasswordView from '../views/ResetPasswordView.vue';
import HomeView from '../views/HomeView.vue';
import NotificationsView from '../views/NotificationsView.vue';
import UserListView from '../views/UserListView.vue';
import BookmarkView from '../views/BookmarkView.vue';
import SubscriptionsView from '../views/SubscriptionsView.vue';
import PaymentView from '../views/PaymentView.vue';
import ProfileView from '../views/ProfileView.vue';
import SettingsView from '../views/SettingsView.vue';
import SubBundlesView from '../views/SubBundlesView.vue';
import NotiSettingsView from '../views/NotiSettingsView.vue';
import ActivityView from '../views/ActivityView.vue';
import SecurityView from '../views/SecurityView.vue';
import SocialsView from '../views/SocialsView.vue';
import OtherProfileView from '../views/OtherProfileView.vue';
import MessageView from '../views/MessageView.vue';
import SubpayView from '../views/SubpayView.vue';
import KycView from '../views/KycView.vue';
import CreatorSignupView from '@/views/CreatorSignupView.vue';
import CollectionsView from '@/views/CollectionsView.vue';
import ExploreView from '@/views/ExploreView.vue';
import EarningsView from '@/views/EarningsView.vue';
import PostView from '@/views/PostView.vue';
import RefView from '@/views/RefView.vue';
import Step2View from '@/views/Step2View.vue';


const routes = [
  {
    path: "/",
    name: "sign-up2",
    component: SignupView,
    meta: {
      title: "Create account",
    },
  },
  {
    path: "/sign-up",
    name: "sign-up",
    component: SignupView,
    meta: {
      title: "Create account",
    },
  },
  {
    path: "/sign-in",
    name: "sign-in",
    component: SigninView,
    meta: {
      title: "Sign in",
    },
  },
  {
    path: "/verify",
    name: "verify",
    component: VerifyView,
    meta: {
      requiresAuth: true,
      title: "Verify email",
    },
  },
  {
    path: "/auth",
    name: "auth",
    component: AuthView,
    meta: {
      requiresAuth: true,
      title: "Authentication",
    },
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: ForgotPasswordView,
    meta: {
      title: "Forgot password",
    },
  },
  {
    path: "/forgot-password2",
    name: "forgot-password2",
    component: ForgotPasswordView2,
    meta: {
      title: "Forgot password",
    },
  },
  {
    path: "/reset-password",
    name: "reset-password",
    component: ResetPasswordView,
    meta: {
      title: "Reset password",
    },
  },

  {
    path: "/creator-sign-up",
    name: "creator-sign-up",
    component: CreatorSignupView,
    meta: {
      title: "Creator Sign up",
    },
  },

  // DASHBOARD
  {
    path: "/home",
    name: "home",
    component: HomeView,
    meta: {
      requiresAuth: true,
      title: "Baesnap | Home",
    },
  },

  {
    path: "/explore",
    name: "explore",
    component: ExploreView,
    meta: {
      requiresAuth: true,
      title: "Baesnap | Explore",
    },
  },

  {
    path: "/notifications",
    name: "notifications",
    component: NotificationsView,
    meta: {
      requiresAuth: true,
      title: "Baesnap | Notifications",
    },
  },

  {
    path: "/user-lists",
    name: "user-lists",
    component: UserListView,
    meta: {
      requiresAuth: true,
      title: "Baesnap | User-lists",
    },
  },

  {
    path: "/bookmarks",
    name: "bookmarks",
    component: BookmarkView,
    meta: {
      requiresAuth: true,
      title: "Baesnap | Bookmarks",
    },
  },

  {
    path: "/collections",
    name: "collections",
    component: CollectionsView,
    meta: {
      requiresAuth: true,
      title: "Baesnap | Collections",
    },
  },

  {
    path: "/subscriptions",
    name: "subscriptions",
    component: SubscriptionsView,
    meta: {
      requiresAuth: true,
      title: "Baesnap | Subscriptions",
    },
  },

  {
    path: "/wallet",
    name: "payments",
    component: PaymentView,
    meta: {
      requiresAuth: true,
      title: "Baesnap | Wallet",
    },
  },

  {
    path: "/earnings",
    name: "earnings",
    component: EarningsView,
    meta: {
      requiresAuth: true,
      title: "Baesnap | Earnings",
    },
  },

  {
    path: "/profile",
    name: "profile",
    component: ProfileView,
    meta: {
      requiresAuth: true,
      title: "Baesnap | " + sessionStorage.getItem("userName"),
    },
  },

  {
    path: "/settings",
    name: "settings",
    component: SettingsView,
    meta: {
      requiresAuth: true,
      title: "Baesnap | Settings",
    },
  },

  {
    path: "/subscription-bundles",
    name: "sub-bundles",
    component: SubBundlesView,
    meta: {
      requiresAuth: true,
      title: "Baesnap | Subscription bundles",
    },
  },

  {
    path: "/notification-settings",
    name: "noti-settings",
    component: NotiSettingsView,
    meta: {
      requiresAuth: true,
      title: "Baesnap | Notification settings",
    },
  },

  {
    path: "/activity-monitor",
    name: "activity-monitor",
    component: ActivityView,
    meta: {
      requiresAuth: true,
      title: "Baesnap | Activity monitor",
    },
  },

  {
    path: "/security-settings",
    name: "security-settings",
    component: SecurityView,
    meta: {
      requiresAuth: true,
      title: "Baesnap | Security",
    },
  },

  {
    path: "/connect-socials",
    name: "connect-socials",
    component: SocialsView,
    meta: {
      requiresAuth: true,
      title: "Baesnap | Connect socials",
    },
  },

  {
    path: "/profiles/:id",
    name: "other-profile",
    component: OtherProfileView,
    meta: {
      requiresAuth: false,
      title: "Baesnap | Profile",
    },
  },

  {
    path: "/messages",
    name: "messages",
    component: MessageView,
    meta: {
      requiresAuth: true,
      title: "Baesnap | Messages",
    },
  },

  {
    path: "/subscribe",
    name: "sub-pay",
    component: SubpayView,
    meta: {
      requiresAuth: true,
      title: "Baesnap | Subscribe",
    },
  },

  {
    path: "/become-a-model",
    name: "kyc",
    component: KycView,
    meta: {
      requiresAuth: true,
      title: "Baesnap | Become a model",
    },
  },

  {
    path: "/post/:id",
    name: "post",
    component: PostView,
    meta: {
      requiresAuth: false,
      title: "Baesnap | Post",
    },
  },

  {
    path: "/referrals",
    name: "referral",
    component: RefView,
    meta: {
      requiresAuth: true,
      title: "Baesnap | Referral",
    },
  },

  {
    path: "/step2",
    name: "step2",
    component: Step2View,
    meta: {
      
      title: "Baesnap | Step2",
    },
  },

];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return {
      top: 0,
    };
  },
});

const getCurrentUser = () => {

  return new Promise((resolve, reject) => {
    const removeListener = onAuthStateChanged(
      getAuth(),
      (user) => {
        removeListener();
        resolve(user);
      },
      reject
    )
  })

}

router.beforeEach(async (to, from, next) => {
  if(to.matched.some((record) => record.meta.requiresAuth)){

    if(await getCurrentUser()){
      next();
    }
    else{
      //alert("You do not have access");
      next({name: "sign-in"});
    }

  }
  else{
    next();
  }
} )

router.afterEach((to, from) => {
  nextTick(()=>{
    document.title = to.meta.title
  })
})

export default router
